
/* Veranda Vale - Exclusive heater accordions */

function setupVVHeaterAccordions() {
  const headings = document.querySelectorAll(
    "details > summary"
  );

  headings.forEach((heading, index) => {
    if (
      heading.textContent.trim() !==
      "Compare Heater Packages"
    ) return;

    const outer = heading.parentElement;

    const rows = outer.querySelectorAll(
      "accordion-custom > details"
    );

    rows.forEach((row) => {
      if (
        row.parentElement.closest("details") === outer
      ) {
        row.setAttribute(
          "name",
          `vv-heater-group-${index}`
        );
      }
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    setupVVHeaterAccordions
  );
} else {
  setupVVHeaterAccordions();
}

document.addEventListener(
  "shopify:section:load",
  setupVVHeaterAccordions
);
